import { companies, company_devices } from 'database';

import { createSelectSchema } from "drizzle-zod";
import { z } from "zod";

export const CompanyModel = createSelectSchema(companies);
export type CompanyModel = z.infer<typeof CompanyModel>;

export const CompanyDeviceModel = createSelectSchema(company_devices);
export type CompanyDeviceModel = z.infer<typeof CompanyDeviceModel>;